import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { SORT_OPTIONS } from './constants';
import Select from '../select';
import withTranslate from '../../hoc/with-translate';

const getOptions = t =>
  _.map(SORT_OPTIONS, (translation, value) => ({
    value,
    label: t(translation),
  }));

const MembersSortFieldDesktop = ({ value, t, ...props }) =>
  <Select defaultValue={value} options={getOptions(t)} height={60} isTransparent isScrollable={false} {...props}/>;

MembersSortFieldDesktop.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func,
};

export default withTranslate(MembersSortFieldDesktop);



// WEBPACK FOOTER //
// ./app/components/member-sort-field/member-sort-field-desktop.js